export default __webpack_public_path__ + "static/media/gyroZ.4aba51e7.svg";